/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_No_DataInputs */

const en_coach_no_data = /** @type {(inputs: Coach_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough data yet. Upload sessions to get recommendations.`)
};

const de_coach_no_data = /** @type {(inputs: Coach_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht genug Daten. Lade Einheiten hoch, um Empfehlungen zu bekommen.`)
};

/**
* | output |
* | --- |
* | "Not enough data yet. Upload sessions to get recommendations." |
*
* @param {Coach_No_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_no_data = /** @type {((inputs?: Coach_No_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_No_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_no_data(inputs)
	return de_coach_no_data(inputs)
});